import { useEffect, useState } from "react";
import CustomValuesHook from "../../Hooks/customValuesHook";
import headings from "../../constants/headings";
import { ErrorToast, NotLogin } from "../../shared";
import GSPTable from "../../shared/GSFTable";
import { getSensitiveWords } from "../../api/requestAxios/sensitiveWord";
import "./style.scss";
import { ToPersianNumber } from "../../functions";
import EditOrAddWord from "./editOrAddWord";
import RemoveWord from "./removeWord";

const SensitiveWord = (props) => {
  const [wordList, setWordList] = CustomValuesHook({
    pageIndex: 1,
    pageNumber: 1,
    pageSize: 25,
    totalCount: 0,
    data: [],
  });

  const [val, setVal] = CustomValuesHook({
    loading: false,
    showEditModal: false,
    showRemoveModal: false,
    itemselected: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setVal({ loading: true });
      const response = await getSensitiveWords({
        pageSize: 10,
        pageNumber: 1,
        disablePaging: false,
        sortText: "",
        whereConditionText: "",
      });

      response?.data?.data?.forEach((item, index) => {
        item.row = ToPersianNumber(index + 1);
      });

      setWordList({
        pageIndex: response?.pageIndex,
        pageNumber: response?.pageNumber,
        pageSize: response?.pageSize,
        totalCount: response?.totalCount,
        data: response?.data?.data,
      });
      setVal({ loading: false });
    } catch (err) {
      setVal({ loading: false });

      ErrorToast(err);
    }
  };
  const optionComponent = ({ item }) => {
    return (
      <div className="d-flex justify-content-start align-items-center option-wrapper">
        <span
          onClick={() => {
            setVal({ showEditModal: true, itemselected: item, mood: "edit" });
          }}
        >
          ویرایش
        </span>
        <span
          onClick={() => {
            setVal({ showRemoveModal: true, itemselected: item });
          }}
        >
          حذف
        </span>
      </div>
    );
  };

  const columns = [
    {
      title: "ردیف",
      property: "row",
      filterProperty: "null",
      hasSort: false,
      hasFilter: false,
      display: true,
    },
    {
      title: "کلمات مشکوک",
      property: "term",
      filterProperty: null,
      hasSort: true,
      hasFilter: false,
      display: true,
    },
    {
      title: "گزینه ها",
      property: "LastModifiedDate",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: optionComponent,
    },
  ];

  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-service-container">
            <div className="user-info"></div>
            <div className="sensitive-word-list">
              <div className="d-flex justify-content-between align-items-center header-wrapper mt-3">
                <div>لیست کلمات حساس</div>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setVal({
                      mood: "add",
                      showEditModal: true,
                      itemselected: "",
                    });
                  }}
                >
                  اضافه کردن کلمه‌ی جدید
                </button>
              </div>
              {!val?.loading ? (
                <div>
                  {wordList?.data?.length > 0 ? (
                    <div>
                      <GSPTable
                        // apiCall={getData}
                        columns={columns}
                        hasSorting={false}
                        dataList={wordList}
                        // options={options}
                        hasFiltering={false}
                        isSearchByExternalBtn={false}
                        // loading={val?.loading}
                        enableScrolling={false}
                        searchBtnText={"جستجو"}
                        isStepScrolling={false}
                        // setDataListFromItem={setEmailList}
                      />
                    </div>
                  ) : (
                    <div className="no-data">اطلاعات وجود ندارد</div>
                  )}
                </div>
              ) : (
                <div
                  className="spinner-border"
                  role="status"
                  aria-hidden="true"
                ></div>
              )}
            </div>
          </div>
          {val?.showEditModal && (
            <EditOrAddWord
              val={val}
              setVal={setVal}
              item={val?.itemselected}
              getData={getData}
            />
          )}
          {val?.showRemoveModal && (
            <RemoveWord
              val={val}
              setVal={setVal}
              item={val?.itemselected}
              getData={getData}
            />
          )}
        </>
      )}
    </main>
  );
};
export default SensitiveWord;
